import * as bootstrap from 'bootstrap';

jQuery(document).ready(function ($) {

    const userId = $('body').data('user-id');
    const form = $('#configurator');

    let wantsToSimulate = false;

    $('.section-toggle').on('click', function (e) {
        e.preventDefault();
    });

    // Beim Laden der Seite den Zustand wiederherstellen
    $('.section').each(function () {
        const sectionId = $(this).attr('id');
        const savedState = localStorage.getItem(`section-${userId}-${sectionId}`);

        if (savedState === 'false') {
            $(this).attr('aria-expanded', 'false');
            $($(this).data('target')).removeClass('show').attr('aria-expanded', 'false');
        } else if (savedState === 'true') {
            $(this).attr('aria-expanded', 'true');
            $($(this).data('target')).addClass('show').attr('aria-expanded', 'true');
        }
    });

    $('.section-header').on('click', function () {
        const section = $(this).parents('.section');
        const target = $(section.data('target'));
        const sectionId = section.attr('id');

        if (target.length) {
            if (section.attr('aria-expanded') === 'true') {
                section.attr('aria-expanded', 'false');
                target.attr('aria-expanded', 'false').removeClass('show');
                if (target.find('video').length > 0) {
                    target.find('video').get(0).pause();
                }
                localStorage.setItem(`section-${userId}-${sectionId}`, 'false');
            } else {
                section.attr('aria-expanded', 'true');
                target.attr('aria-expanded', 'true').addClass('show');
                localStorage.setItem(`section-${userId}-${sectionId}`, 'true');
            }
        }
        return false;
    });

    $('.section-button').on('click', function () {
        const target = $($(this).data('target'));
        if (target.length) {
            if (target.attr('aria-expanded') === 'true') {
                target.attr('aria-expanded', 'false').removeClass('show');
                if (target.find('video').length > 0) {
                    target.find('video').get(0).pause();
                }
            } else {
                target.attr('aria-expanded', 'true').addClass('show');
            }
        }
        return false;
    });

    form.find('.group-select').on('change', function (e) {
        const button = form.find('.material-groups:visible button[data-action="wizard.select"].selected');
        if (button.hasClass('custom-group')) {
            form.find('.material-groups:visible button[data-action="group.edit"]').show();
        } else {
            form.find('.material-groups:visible button[data-action="group.edit"]').hide();
        }

        if ($(this).attr('id') === '#tg') {
            const currentValue = $(this).val();
            $('#texts_table tbody tr').addClass('d-none');
            $('#texts_table input[type="checkbox"]').prop('checked', false);
            $('#texts_table tbody tr.textgroup_' + currentValue).removeClass('d-none');
        }
    });

    /**
     *  Form Stuff
     *  ------------------------------------------------------------------------
     */
    const saveDashboardSettings = function () {
        console.log('saving form settings');
        let formdata = readDashboardSettings();
        localStorage.setItem(`dashboard-${userId}-form`, JSON.stringify(formdata));
    }

    const applyDashboardSettings = function (previous_settings) {
        if (previous_settings.excercise === 'simulate') {
            previous_settings.excercise = 'tippen';
        }
        console.log('apply dashboard settings for user', userId);

        form.find('input:checked').prop('checked', false);

        if (previous_settings && previous_settings.material) {
            selectMaterial(previous_settings.material);
        } else {
            form.addClass('form-type-words'); // default
        }

        if (previous_settings && previous_settings.type) {
            selectType(previous_settings.type);
        } else {
            form.addClass('form-config-lesen'); // default
        }

        form.find('.preset-special').hide();

        $.each(previous_settings, function (key, value) {
            if (key.indexOf('e_') === -1 && key.indexOf('v_') === -1 && key.indexOf('vs_') === -1 && key.indexOf('at_') === -1 && key.indexOf('k_') === -1) {
                console.log('restore setting:', key, value);

                let elem = $('#' + key);

                if (typeof value == 'boolean') {
                    elem.prop('checked', value);
                } else {
                    elem.val(value);

                    if (elem.prop('tagName') === 'SELECT') {

                        $('button[data-target="#' + key + '"]').removeClass('selected');
                        $('button[data-target="#' + key + '"][data-value="' + value + '"]').addClass('selected');

                        if ($('button[data-target="#' + key + '"][data-value="' + value + '"]').hasClass('preset-only')) {
                            $('button[data-target="#' + key + '"]').parents('.group-buttons').find('.preset-special').show();
                        }

                        $('div.card[data-target="#' + key + '"]').removeClass('selected');
                        $('div.card[data-target="#' + key + '"][data-value="' + value + '"]').addClass('selected');
                    }
                }

            }
        });

        if (previous_settings && previous_settings.tg) {
            $('#texts_table tbody tr').addClass('d-none');
            if (previous_settings.material === 'texts') {
                $('#texts_table tbody tr.textgroup_' + previous_settings.tg).removeClass('d-none');
            }
        }

    };

    const readDashboardSettings = function () {
        let formdata = {};
        form.find('input,select,textarea').each(function () {
            let type = $(this).attr('type');
            let id = $(this).attr('id');
            let value = $(this).val();

            if (!$(this).hasClass('ignore-save')) {
                if (id) {
                    if (type === 'checkbox') {
                        if ($(this).prop('checked')) {
                            formdata[id] = true
                        }
                    } else if (type === 'radio') {
                        if ($(this).prop('checked')) {
                            formdata[id] = true
                        }
                    } else {
                        formdata[id] = value;
                    }
                }
            }
        });
        return formdata;
    }

    /**
     *  Tab Navigation
     *  ------------------------------------------------------------------------
     */
    const activateTab = function (targetElement) {
        $('#customizer .nav-link').removeClass('active').attr('aria-selected', 'false');
        $('#customizer .tab-pane').removeClass('active');

        $('#customizer').find(targetElement.attr('href')).addClass('active');

        targetElement.addClass('active').attr('aria-selected', 'true');


        window.setTimeout(function () {
            $('#configurator .group-select').trigger('change');
        }, 50)
    }

    const selectType = function (type) {
        form.removeClass('form-config-lesen');
        form.removeClass('form-config-hoeren');

        if (type) {
            if (type === 'lesen') {
                form.addClass('form-config-lesen');
            }
            if (type === 'hoeren') {
                form.addClass('form-config-hoeren');
            }
        }

        $('#configurator .excercise-select').trigger('change');
    }

    const selectMaterial = function (material) {
        form.removeClass('form-type-texts');
        form.removeClass('form-type-words');
        form.removeClass('form-type-sentences');
        form.removeClass('form-type-texts');

        if (material) {
            if (material === 'words') {
                form.addClass('form-type-words');
            }
            if (material === 'sentences') {
                form.addClass('form-type-sentences');
            }
            if (material === 'texts') {
                form.addClass('form-type-texts');
            }
        }

        $('#configurator .group-select').trigger('change');
    }

    $('#configurator .nav-link').on('click', function (e) {
        window.setTimeout(function () {
            $('#configurator .group-select').trigger('change');
        }, 50)
    });

    /**
     *  Configurator Buttons
     *  ------------------------------------------------------------------------
     */
    $(document).on('click', '#configurator button', function (e) {
        let button = $(this);
        let action = button.data('action');
        let formdata = readDashboardSettings();
        let excercise_select = $('#excercise');
        let relatedButton;
        let activePane = $('#custom_excercise .tab-pane.active');

        if (action === 'launch') {
            if (wantsToSimulate && (typeof e.originalEvent === 'undefined')) {
                excercise_select.prop('selectedIndex', $('#excercise option[value="simulate"]').index());
                wantsToSimulate = false;
                return true;
            } else {
                wantsToSimulate = false;
                if (excercise_select.val() === 'simulate') {
                    console.log('fix admins mis-select');
                    // the user does not actually want to simulate
                    // => reset to something sensible.
                    excercise_select.prop('selectedIndex',
                        $('#excercise option[value="schreiben"]').index()
                    );
                }
            }
            return true;
        }

        if (action === 'simulate') {
            wantsToSimulate = true;
            $('#excercise').prop('selectedIndex',
                $('#excercise option[value="simulate"]').index()
            );
            $('#submit').click();
            return false;
        }

        if (action === 'wizard.next') {
            let visibleItems = $('#customizer .nav-item:visible');
            let currentIndex = 0;

            visibleItems.each(function (i, item) {
                if ($(item).find('.nav-link.active').length) {
                    currentIndex = i;
                }
            });

            if (activePane.attr('id') === 'customizer_pane_3') {
                if (!($('[data-target="#type"].selected:visible').length)) {
                    alert('Bitte wähle zwischen Lesen oder Hören');
                    return false;
                }
            }

            if (activePane.attr('id') === 'customizer_pane_4') {
                if (!($('[data-target="#excercise"].selected:visible').length)) {
                    alert('Bitte wähle eine Übungsform aus');
                    return false;
                }
            }

            let nextTab = $(visibleItems.get(currentIndex + 1));
            if (nextTab && $(nextTab).length) {
                let nextLink = $(nextTab).find('.nav-link');
                activateTab(nextLink);
            }
            return true;
        }

        if (action === 'wizard.tab') {
            let target = $(this).attr('data-bs-target');
            let targetElement = $(target);
            activateTab(targetElement);
            return true;
        }

        if (action === 'wizard.select') {
            let button = $(this);
            let select = $(button.data('target'));
            let currentValue = select.val();
            let nextValue = button.data('value');
            let option = select.find('option[value="' + nextValue + '"]');

            // apply option
            select.prop('selectedIndex', option.index());
            select.trigger('change');

            if (button.hasClass('preset-only')) {
                button.parents('.group-buttons').find('.preset-special').show();
            } else {
                button.parents('.group-buttons').find('.preset-special').hide();
            }

            $('button[data-target="' + $(this).data('target') + '"]').removeClass('selected');
            relatedButton = $('button[data-target="' + $(this).data('target') + '"][data-value="' + $(this).data('value') + '"]');
            relatedButton.addClass('selected');

            if ($(this).data('target') === '#material') {
                selectMaterial($(this).data('value'));
            }

            if ($(this).data('target') === '#type') {
                selectType($(this).data('value'));
            }

            if ($(this).data('target') === '#tg' || ($(this).data('target') === '#material' && $(this).data('value') === 'texts')) {
                // clear checked boxes in the current group
                if (parseInt(nextValue, 10) !== parseInt(currentValue, 10)) {
                    $('#texts_table input[type="checkbox"]').prop('checked', false);
                }
                // show text rows
                $('#texts_table tbody tr').addClass('d-none');

                if (nextValue === 'texts') {
                    $('#texts_table tbody tr.textgroup_1').removeClass('d-none');
                } else {
                    $('#texts_table tbody tr.textgroup_' + currentValue).removeClass('d-none');
                }
            }

            saveDashboardSettings();

            form.find('.group-select').trigger('change');

            return true;
        }

        if (action === 'wizard.card') {
            let card = $(this).parents('.card');
            let cardselect = $(card.data('target'));
            let cardoption = cardselect.find('option[value="' + card.data('value') + '"]');
            cardselect.prop('selectedIndex', cardoption.index());
            cardselect.trigger('change');

            card.parents('.card-group').find('.card').removeClass('selected');
            card.addClass('selected');

            let select = $($(this).data('target'));
            let option = select.find('option[value="' + $(this).data('value') + '"]');
            select.prop('selectedIndex', option.index());
            select.trigger('change');

            $('button[data-target="' + $(this).data('target') + '"]').removeClass('selected');
            relatedButton = $('button[data-target="' + $(this).data('target') + '"][data-value="' + $(this).data('value') + '"]');
            relatedButton.addClass('selected');

            saveDashboardSettings();

            return true;
        }

        /**
         * CUSTOM CONTENT
         * --------------------------------------------------------------------------------------------------------
         */
        const createModal = $('#contentCreateModal');
        const createModalBody = $('#contentCreateBody');
        const editModal = $('#contentEditModal');
        const editModalBody = $('#contentEditBody');

        const currentlySelectedGroup = function () {
            return $('.material-groups.active .custom-group.selected').data('value');
        }

        createModal.on('hidden.bs.modal', function () {
            createModalBody.html('');
        });

        if (action === 'group.create') {
            let type = button.data('type');
            let url = button.data('url');

            createModal.data('type', type);
            createModal.data('url', url);

            $.get(url, function (data) {
                createModalBody.html(data);
                createModal.modal('show');
            });
            return false;
        }

        if (action === 'group.save') {
            let type = createModal.data('type');
            let url = createModal.data('url');
            let form = createModalBody.find('fieldset');

            $.post(url, form.serialize(), function (data) {
                const select = $('.material-groups.active').find('.group-select');
                let target = '';

                if (type === 'wordgroup') {
                    window.wgsettings[data.id] = [];
                    target = '#ws';
                }
                if (type === 'sentencegroup') {
                    window.sgsettings[data.id] = [];
                    target = '#sg';
                }
                if (type === 'textgroup') {
                    window.tgsettings[data.id] = [];
                    target = '#tg';
                }

                select.append('<option value="' + data.id + '">' + data.name + '</option>');

                let buttonHtml = '\n' +
                    '<button class="btn btn-outline-primary custom-group px-10 py-4 p-md-10 me-3 mb-3"\n' +
                    ' type="button"\n' +
                    ' data-target="' + target + '" data-action="wizard.select"\n' +
                    ' data-value="' + data.id + '">' + data.name + '</button>';

                $('div.custom-groups[data-target="' + target + '"]').append(buttonHtml);

                createModal.modal('hide');
            });
            return false;
        }

        if (action === 'group.edit') {
            let type = button.data('type');
            let url = button.data('url') + '/' + currentlySelectedGroup();

            editModal.data('type', type);
            editModal.data('url', url);

            $.get(url, function (data) {
                editModalBody.html(data);
                editModal.modal('show');
            });

            return false;
        }

        if (action === 'group.update') {
            let type = editModal.data('type');
            let url = editModal.data('url');
            let form = editModalBody.find('fieldset');

            $.post(url, form.serialize(), function (data) {
                editModal.modal('hide');
            });
            return false;
        }

        if (action === 'group.delete') {
            let url = editModal.data('url');
            let groupId = currentlySelectedGroup();
            if (confirm('Wirklich löschen?')) {
                $('button.default-group:first').click();
                $('button.custom-group[data-value="' + groupId + '"]').remove();

                $.post(url, {delete: 1}, function () {
                    editModal.modal('hide');
                });

                saveDashboardSettings();
            }
            return false;
        }

        /**
         * PRESET MANAGEMENT
         * --------------------------------------------------------------------------------------------------------
         */
        const preset_select = $('#preset_select');
        const preset_name = $('#preset_name');
        const preset_descr = $('#preset_descr');
        const type_modal = $('#typeWizardModal');

        if (action === 'preset.custom') {
            return false;
        }

        if (action === 'preset.launch') {
            let textarea = $('#' + button.data('settings'));
            let fieldset = $('#customizer_pane_3 .card-group');
            let fieldset2 = $('#customizer_pane_4 .card-group');
            let form = fieldset.parents('form');

            let originalParent = fieldset.parent();
            let originalParent2 = fieldset2.parent();
            let originalIndex = fieldset.index();
            let originalIndex2 = fieldset2.index();

            applyDashboardSettings(JSON.parse(textarea.val()));

            const fieldsetWrapper = $('<div class="collapse show" id="fieldsetStep1"></div>').append(fieldset);
            const fieldset2Wrapper = $('<div class="collapse" id="fieldsetStep2"></div>').append(fieldset2);

            type_modal.find('.modal-body')
                .append(fieldsetWrapper)
                .append(fieldset2Wrapper);

            fieldsetWrapper.find('.btn').on('click', function () {
                $('#fieldsetStep1').collapse('hide');
                $('#fieldsetStep2').collapse('show');
            });


            type_modal.modal('show');
            type_modal.find('.modal-footer button[type=submit]').off('click').on('click', function () {
                form.data('wasSubmitted', true);
                $('#submit').click();
            });
            type_modal.off('hidden.bs.modal').on('hidden.bs.modal', function () {
                if (!form.data('wasSubmitted')) {
                    $('#fieldsetStep1, #fieldsetStep2').collapse('dispose');
                    if (originalIndex >= originalParent.children().length) {
                        originalParent.append(fieldset);
                    } else {
                        fieldset.insertBefore(originalParent.children().eq(originalIndex));
                    }
                    if (originalIndex2 >= originalParent2.children().length) {
                        originalParent2.append(fieldset2);
                    } else {
                        fieldset2.insertBefore(originalParent2.children().eq(originalIndex2));
                    }
                }
            });

            return false;
        }

        if (action === 'preset.create') {
            let preset_name_val = preset_name.val() + '';
            let preset_descr_val = preset_descr.val() + '';

            if (preset_name_val.length) {
                $.post('/admin/profiles', {
                    description: preset_descr_val,
                    name: preset_name_val,
                    settings: formdata
                }).done(function (data) {
                    console.log('create', data);
                    if (data.success) {
                        preset_select.append('<option value="' + data.profile.id + '">' + data.profile.name + ' (Neu!)</option>');
                        button.addClass('flash-success');
                        window.setTimeout(function () {
                            button.removeClass('flash-success');
                        }, 300);
                    } else {
                        button.addClass('flash-danger');
                        window.setTimeout(function () {
                            button.removeClass('flash-danger');
                        }, 300);
                    }
                });
            } else {
                preset_name.focus();
            }
            return false;
        }

        if (action === 'preset.view') {
            let preset_id = preset_select.val();
            if (preset_id) {
                location.href = '/admin/profiles/' + preset_id;
            } else {
                preset_select.focus();
            }
            return false;
        }

        if (action === 'preset.delete') {
            let preset_id = preset_select.val();
            if (preset_id) {
                if (confirm("Möchten Sie wirklich das Profil entfernen?")) {
                    $.post('/admin/profiles/' + preset_id + '/save', {
                        _method: 'PUT',
                        id: preset_id,
                        'delete': 1
                    }).done(function (data) {
                        if (data.success) {
                            preset_select.find('option[value="' + preset_id + '"]').remove();
                            preset_select.prop('selectedIndex', preset_select.find('option:first').index());
                            $('.profile-column[data-id="' + preset_id + '"]').remove();

                            button.addClass('flash-success');
                            window.setTimeout(function () {
                                button.removeClass('flash-success');
                            }, 300);
                        }
                    });
                }
            } else {
                preset_name.focus();
            }
            return false;
        }
        if (action === 'preset.update') {
            let preset_id = preset_select.val();
            if (preset_id) {
                $.post('/admin/profiles/' + preset_id + '/save', {
                    _method: 'PUT',
                    id: preset_id,
                    settings: formdata
                }).done(function (data) {
                    if (data.success) {
                        button.addClass('flash-success');
                        window.setTimeout(function () {
                            button.removeClass('flash-success');
                        }, 300);
                    } else {
                        button.addClass('flash-danger');
                        window.setTimeout(function () {
                            button.removeClass('flash-danger');
                        }, 300);
                    }
                });
            } else {
                preset_name.focus();
            }
            return false;
        }

        if (action === 'preset.load') {
            let preset_id = preset_select.val();
            if (preset_id) {
                $.get('/admin/profiles/' + preset_id + '/load').done(function (data) {
                    console.log('load', data);
                    if (data.success) {
                        applyDashboardSettings(data.settings);
                        button.addClass('flash-success');
                        window.setTimeout(function () {
                            button.removeClass('flash-success');
                        }, 300);
                    } else {
                        button.addClass('flash-danger');
                        window.setTimeout(function () {
                            button.removeClass('flash-danger');
                        }, 300);
                    }
                });
            } else {
                preset_select.focus();
            }
            return false;
        }
    });


    /**
     *  Save on keydown in any field
     *  ------------------------------------------------------------------------
     */
    $(document).on('input', 'form.lernconfig', function (e) {
        if ($(e.target).hasClass('ignore-save')) {
            return true;
        }
        saveDashboardSettings();
    });


    /**
     *  Update hidden selects
     *  ------------------------------------------------------------------------
     */
    $(document).on('click', 'div.card .card-macro-btns input', function (e) {
        e.preventDefault();
        let card = $(this).parents('.card');
        let target_value = parseInt($(this).data('select'), 10);
        card.find('.card-body input:checked').prop('checked', false);
        card.find('.card-body input[value="' + target_value + '"]').prop('checked', true);
    });

    $(document).on('change', 'form.lernconfig #ws', function (e) {
        let wg_id = $(this).val();

        $('#schwerpunkte').addClass('d-none');
        $('.sp-kategorie').addClass('d-none');
        $('.sp-selector').addClass('d-none').removeClass('d-flex');
        $('.sp-selector input').each(function () {
            let name = $(this).attr('name');
            $(this).data('name', name);
            $(this).removeAttr('name');
        });

        if (window.wgsettings && typeof window.wgsettings[wg_id] !== 'undefined') {
            let schwerpunkte = window.wgsettings[wg_id];
            $('#schwerpunkte').removeClass('d-none');

            $.each(schwerpunkte, function (i, id) {

                if (id.substring(0, 2) === 'at') {
                    $('#schwerpunkte_at').removeClass('d-none');
                }
                if (id.substring(0, 2) === 'vs') {
                    $('#schwerpunkte_vs').removeClass('d-none');
                }
                if (id.substring(0, 1) === 'k') {
                    $('#schwerpunkte_k').removeClass('d-none');
                }
                if (id.substring(0, 1) === 'v') {
                    $('#schwerpunkte_v').removeClass('d-none');
                }
                if (id.substring(0, 1) === 'e') {
                    $('#schwerpunkte_e').removeClass('d-none');
                }

                $('#' + id).parents('.sp-selector').removeClass('d-none').addClass('d-flex');

                $('#' + id + ' input').each(function () {
                    $(this).attr('name', $(this).data('name'));
                });
            });
        }
    });


    /**
     *  Start Worte suchen (autocomplete)
     *  ------------------------------------------------------------------------
     */
    const starterInput = $('#starters');
    if (starterInput.length) {
        starterInput.tagsInput({
            placeholder: 'Wort suchen',
            minChars: 2,
            maxChars: 10,
            limit: 10,
            autocomplete: {
                source: starterInput.data('source'),
                width: '100px',
                autoFill: true
            }
        });
    }

    /**
     *  Load Settings on page init
     *  ------------------------------------------------------------------------
     */
    if (form.length > 0) {

        const form_defaults = {
            "material": "words",
            "ws": "1",
            "mix": "20",
            "type": "lesen",
            "excercise": "tippen",
            "time": "10",
            "limit": "50"
        }

        let previous_settings = localStorage.getItem(`dashboard-${userId}-form`);
        if (previous_settings && previous_settings.length !== 0) {
            previous_settings = JSON.parse(previous_settings);
            applyDashboardSettings(previous_settings);
        } else {
            applyDashboardSettings(form_defaults);
        }
    }


});
